$('.filters-button').on('click', (e) => {
  if (innerWidth >= 768) {
    if (!$(e.currentTarget).hasClass('is-active')) {
      $('.header__filters').slideDown(250, () => {
        $('.header__filters__bg').fadeIn(250);
      });
      $(e.currentTarget).addClass('is-active');
      $('.header').addClass('is-fixed');
    } else {
      $(document).find('.header__filters__content').slideUp();
      $(document).find('.header__filters__item').removeClass('is-active');
      $('.header__filters__bg').fadeOut(250, () => {
        $('.header__filters').slideUp(250);
        $(e.currentTarget).removeClass('is-active');

        if ($(document).scrollTop() <= $('.header').height()) {
          $('.header').removeClass('is-fixed');
        }
      });
    }
  } else {
    if (!$(e.currentTarget).hasClass('is-active')) {
      $('.burger').removeClass('is-active');
      $('.header .rightside').fadeOut(() => {
        $('.header__filters').slideDown(250, () => {
          $('.header__filters__bg').fadeIn(250);
        });
        $(e.currentTarget).addClass('is-active');
      });
    }
  }
});

$('.header__filters__close').on('click', () => {
  $(document).find('.header__filters__content').slideUp();
  $(document).find('.header__filters__item').removeClass('is-active');
  $('.header__filters__bg').fadeOut(250, () => {
    $('.header__filters').slideUp(250);
    $('.filters-button').removeClass('is-active');

    if ($(document).scrollTop() <= $('.header').height()) {
      $('.header').removeClass('is-fixed');
    }
  });
})

$('.header__filters__bg').on('click', () => {
  $(document).find('.header__filters__content').slideUp();
  $(document).find('.header__filters__item').removeClass('is-active');
  $('.header__filters__bg').fadeOut(250, () => {
    $('.header__filters').slideUp(250);
    $('.filters-button').removeClass('is-active');

    if ($(document).scrollTop() <= $('.header').height()) {
      $('.header').removeClass('is-fixed');
    }
  });
});

$('.header__filters__item').on('click', (e) => {
  let $this = $(e.currentTarget);
  let $content = $(document).find(`.header__filters__content[data-content="${$this.data('item')}"]`);

  if (!$this.hasClass('is-active')) {
    $(document).find('.header__filters__content').slideUp();
    $('.header__filters__item').removeClass('is-active');
    $content.slideDown();
    $this.addClass('is-active')
  } else {
    $content.slideUp();
    $this.removeClass('is-active')
  }
});

$('.header__filters__content__hide').on('click', (e) => {
  $('.header__filters__item').removeClass('is-active');
  $(e.currentTarget).closest('.header__filters__content').slideUp();
});

$('.js-filter-item').on('click', (e) => {
  const $parent = $(e.currentTarget).closest('.header__filters__content');
  const data = $parent.data('content');

  $(e.currentTarget).toggleClass('is-active');
  if ($parent.find('.js-filter-item.is-active').length > 0) {
    $parent.find('.header__filters__content__buttons-container').slideDown();
    $(`.header__filters__item[data-item="${data}"] span`).text(`${$parent.find('.js-filter-item.is-active').length} `);
  } else {
    $(`.header__filters__item[data-item="${data}"] span`).text('');
    $parent.find('.header__filters__content__buttons-container').slideUp();
  }

  if ($(document).find('.js-filter-item.is-active').length > 0) {
    $('.header__filters__reset').removeClass('not-active');
  } else {
    $('.header__filters__reset').addClass('not-active');
  }
})

$('.header__filters .button-reset').on('click', (e) => {
  const $parent = $(e.currentTarget).closest('.header__filters__content');
  const data = $parent.data('content');

  $parent.find('.js-filter-item').removeClass('is-active');
  $parent.find('.header__filters__content__buttons-container').slideUp();
  $(`.header__filters__item[data-item="${data}"] span`).text('');

  if ($(document).find('.js-filter-item.is-active').length > 0) {
    $('.header__filters__reset').removeClass('not-active');
  } else {
    $('.header__filters__reset').addClass('not-active');
  }
});

$('.header__filters__reset').on('click', () => {
  $(document).find('.js-filter-item').removeClass('is-active');
  $(document).find('.header__filters__content__buttons-container').slideUp();
  $('.header__filters__item span').text('');

  if ($(document).find('.js-filter-item.is-active').length > 0) {
    $('.header__filters__reset').removeClass('not-active');
  } else {
    $('.header__filters__reset').addClass('not-active');
  }
});